module.exports = __webpack_public_path__ + "img/businessTwo.52c249bf.svg";